/**
 * Where a resolved sticker goes. The answer of POST /scanner/lookup, as a route.
 *
 * Shared by the dashboard lookup widget and /parts/lookup so the two cannot
 * disagree about which page a sticker opens. The widget handles one case before
 * asking: a board that sits in a drone arms Go / Flag in place instead of
 * leaving the dashboard.
 */
export type ScanKind = 'drone' | 'board' | 'part_instance' | 'asset' | 'box' | 'unknown';

export interface ScanLookupResult {
  kind: ScanKind;
  payload: any;
}

/** The route for a lookup result, or null when nothing has a page to open. */
export function scanDestination({ kind, payload }: ScanLookupResult): string | null {
  if (!payload) return null;
  switch (kind) {
    case 'drone':
      return payload.serialnumber ? `/drone/${payload.serialnumber}` : null;
    case 'board':
      return payload.primary_uid ? `/board/${payload.primary_uid}` : null;
    case 'part_instance':
      return payload.id ? `/part/${payload.id}` : null;
    case 'asset':
      return payload.id != null ? `/assets/${payload.id}` : null;
    default:
      return null;
  }
}
